export class AppError {
    constructor(public status: string, public message?: string, public data?: Object) {
    }
    static fromError(error: Error): AppError {
        return new AppError(error.message);
    }
}
